// import {AuthModel} from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
const IMPERSONATOR_AUTH_LOCAL_STORAGE_KEY = 'cultiva-impersonator-auth'
const getAuth = (): string | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: string = JSON.parse(lsValue) as string
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: string) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

const getImpersonatorAuth = (): string | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(IMPERSONATOR_AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    return JSON.parse(lsValue) as string
  } catch (error) {
    console.error('IMPERSONATOR AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setImpersonatorAuth = (auth: string) => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.setItem(IMPERSONATOR_AUTH_LOCAL_STORAGE_KEY, JSON.stringify(auth))
  } catch (error) {
    console.error('IMPERSONATOR AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeImpersonatorAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(IMPERSONATOR_AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('IMPERSONATOR AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axiosInstance: any) {
  axiosInstance.defaults.headers.Accept = 'application/json'
  axiosInstance.interceptors.request.use(
    (config: { headers: { Authorization: string } }) => {
      const auth = getAuth()
      if (auth && auth) {
        config.headers.Authorization = `Bearer ${auth}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

export {
  getAuth,
  setAuth,
  removeAuth,
  getImpersonatorAuth,
  setImpersonatorAuth,
  removeImpersonatorAuth,
  AUTH_LOCAL_STORAGE_KEY,
  IMPERSONATOR_AUTH_LOCAL_STORAGE_KEY,
}
